module.exports = __webpack_public_path__ + "static/axmanova-e136ab81ae5e57fca5f150058d2cccb9.jpg";